// queries/useDeleteAllImageGenerations.ts
"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch } from "libs";
import { DELETE_ALL_IMAGE_GENERATIONS } from "api";

export const useDeleteAllImageGenerations = (modelId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await fetch(`${DELETE_ALL_IMAGE_GENERATIONS}/${modelId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
      
      return await response
    },
    onSuccess: (data) => {
      // Invalidate and refetch relevant queries
      queryClient.invalidateQueries({ queryKey: ["modelCreations", modelId] });
      queryClient.refetchQueries({ queryKey: ["modelCreations", modelId] });
      console.log("Image generations deletion successful:", data.message);
    },
    onError: (error) => {
      console.error("Error in useDeleteAllImageGenerations:", error);
    },
  });
};

export default useDeleteAllImageGenerations;